module.exports = __webpack_public_path__ + "static/media/Descending.Inactive.2e6a16ce.svg";